var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1861_325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 2C7.95 2 7.5 2.45 7.5 3C7.5 3.55 7.95 4 8.5 4C9.05 4 9.5 3.55 9.5 3C9.5 2.45 9.05 2 8.5 2ZM8.5 12C7.95 12 7.5 12.45 7.5 13C7.5 13.55 7.95 14 8.5 14C9.05 14 9.5 13.55 9.5 13C9.5 12.45 9.05 12 8.5 12ZM8.5 7C7.95 7 7.5 7.45 7.5 8C7.5 8.55 7.95 9 8.5 9C9.05 9 9.5 8.55 9.5 8C9.5 7.45 9.05 7 8.5 7Z",
    fill: "#1A202C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1861_325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.e36987bbfccf4589b08be634f7caa72a.svg";
export { ForwardRef as ReactComponent };